import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from 'antd';

import Alert from 'components/Alert/Alert';

import {
  selectActiveApplication,
  selectActiveUserId
} from 'features/applications/applicationsSelectors';
import applicationsService from 'features/applications/applicationsService';

import useErrorCatch from 'hooks/useErrorCatch';

import { AlertType } from 'constants/enums';
import { TOUR_STEP_TARGET_APPLICATION_INTERVIEW_TAB } from 'constants/tour';

import styles from './RequestInterview.module.scss';

interface RequestInterviewProps {
  onRequestSent: () => void;
  isLoading: boolean;
  onLoading: (isLoading: boolean) => void;
}

const RequestInterview: FC<RequestInterviewProps> = ({
  onRequestSent,
  isLoading,
  onLoading
}) => {
  const { t } = useTranslation();

  const catchError = useErrorCatch();
  const applicationId = useSelector(selectActiveUserId);
  const application = useSelector(selectActiveApplication);

  const handleSendInterviewRequest = async () => {
    try {
      onLoading(true);
      await applicationsService.sendInterviewRequest(applicationId);
      onRequestSent();
    } catch (error) {
      catchError({ error });
    } finally {
      onLoading(false);
    }
  };

  return (
    <div id={TOUR_STEP_TARGET_APPLICATION_INTERVIEW_TAB}>
      <h2 className={styles.title}>
        {t('sidebar.application.interview.request.title')}
      </h2>
      <Alert type={AlertType.Info} className={styles.alert}>
        {t('sidebar.application.interview.request.readyToInterview', {
          name: application?.jobseekerFullName,
          job: application?.jobName
        })}
      </Alert>
      {t('sidebar.application.interview.request.askToShare')}
      <Button
        type="primary"
        className={styles.btnFullWidth}
        onClick={handleSendInterviewRequest}
        loading={isLoading}
      >
        {t('sidebar.application.interview.request.inviteForInterview')}
      </Button>
    </div>
  );
};

export default RequestInterview;
